import { isToday, isTomorrow, Locale } from 'date-fns';
import { format } from 'date-fns-tz';
import { t } from 'i18next';

import { DeliverySlot } from '~/api/ETA';

export const getSelectedDaySplited = (
  slot: DeliverySlot,
  timeFormat: string,
  locale?: Locale,
) => {
  const selectedTime = slot
    ? `${format(new Date(slot.delivery_min_time * 1000), timeFormat, {
        timeZone: slot.time_zone,
        locale,
      })}
    -
    ${format(new Date(slot.delivery_max_time * 1000), timeFormat, {
      timeZone: slot.time_zone,
      locale,
    })}`
    : '';

  let selectedDay =
    slot &&
    `${format(new Date(+slot.delivery_min_time * 1000), 'd MMMM', {
      timeZone: slot.time_zone,
      locale,
    })}`;

  if (slot && isToday(new Date(+slot.delivery_min_time * 1000))) {
    selectedDay = t('today');
  } else if (slot && isTomorrow(new Date(+slot.delivery_min_time * 1000))) {
    selectedDay = t('tomorrow');
  }

  return {
    day: selectedDay,
    time: selectedTime,
    date: `${selectedDay} ${selectedTime}`,
  };
};
